module.exports = {"data":{"allMarkdownRemark":{"totalCount":2,"edges":[{"node":{"frontmatter":{"title":"Rakuen","path":"/rakuen"}}},{"node":{"frontmatter":{"title":"To the Moon/Finding Paradise Review","path":"/to-the-moon"}}}]}},"pathContext":{"tag":"Review"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-review.json
// module id = 444
// module chunks = 119609562465818